import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { lotMaster } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const lotMasterSlice = createSlice({
    name: lotMaster,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
          },
        resetDetailParams: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
    
});


export const { setNewEntryMode,setDetailParams, resetDetailParams } = lotMasterSlice.actions;
export default lotMasterSlice.reducer;
